import React from 'react';
import styled from 'styled-components';
import { motion } from 'motion/react';
import { AiChatReference } from '@/features/ai-agents/shared/models';

export interface ChatReferenceTileProps {
  reference: AiChatReference;
  canDelete?: boolean;
  onDelete?: () => void;
}

export function ChatReferenceTile({
  reference,
  canDelete,
  onDelete,
}: ChatReferenceTileProps) {
  const onDeleteClicked = (ev: React.MouseEvent) => {
    if (canDelete && onDelete) {
      ev.stopPropagation();
      onDelete();
    }
  };

  return (
    <Wrapper layout>
      <Caption>{reference.caption}</Caption>
      {canDelete && (
        <ButtonsGroup>
          <DeleteButton onClick={onDeleteClicked}>✕</DeleteButton>
        </ButtonsGroup>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  padding: 0.6rem 1.2rem;
  border-radius: 0.4rem;
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.06);
  border: solid 0.5px #000;
  background-color: #000;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 500;
  position: relative;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
  font-family: Inter, sans-serif;

  user-select: none;
  && * {
    user-select: none;
  }
`;

const Caption = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
`;

const ButtonsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
`;

const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 1.8rem;
  height: 1.8rem;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0;
  flex-shrink: 0;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;
